/* ============================================================
   OSZEA — Contact / Support Hub section
   Vanilla JS, dependency-free, Shopify Theme-Editor friendly.
   Everything is scoped to the section root (.oszea-ct) and
   re-binds on `shopify:section:load` so it stays live while
   editing. Shared chrome (nav / footer / mobile menu) is the
   THEME's responsibility — this file only powers the section.
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.__oszeaCtBound) return;
    root.__oszeaCtBound = true;

    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

    /* ---------- Config (set from Theme-Editor settings via data-attrs) ---------- */
    var cfg = {
      trackUrl:    root.getAttribute('data-track-url')    || '',
      returnsUrl:  root.getAttribute('data-returns-url')  || '',
      trackPage:   root.getAttribute('data-track-page')   || '',
      returnsPage: root.getAttribute('data-returns-page') || '',
      sizeGuide:   root.getAttribute('data-size-guide')   || '',
      trackMode:   root.getAttribute('data-track-mode')   || 'popup',   // 'popup' | 'page'
      exMode:      root.getAttribute('data-exchange-mode')|| 'popup'    // 'popup' | 'page'
    };
    function buildUrl(tpl, data) {
      if (!tpl) return '#';
      return tpl.replace(/\{(\w+)\}/g, function (_, k) { return encodeURIComponent(data[k] || ''); });
    }

    /* ---------- Scroll reveal (position-based — robust everywhere) ---------- */
    root.classList.add('ct-ready');
    var revealEls = $$('.reveal');
    function revealCheck() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      revealEls = revealEls.filter(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > 0) { el.classList.add('in'); return false; }
        return true;
      });
    }
    revealCheck();
    requestAnimationFrame(revealCheck);
    window.addEventListener('scroll', revealCheck, { passive: true });
    window.addEventListener('resize', revealCheck, { passive: true });
    window.addEventListener('load', revealCheck);

    /* ---------- Smooth scroll helper ---------- */
    function scrollToEl(target, offset) {
      if (!target) return;
      var y = target.getBoundingClientRect().top + window.scrollY - (offset || 90);
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    }
    $$('[data-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var t = $(href);
        if (!t) return;
        e.preventDefault();
        var topic = a.getAttribute('data-topic');
        if (topic) preselectTopic(topic);
        scrollToEl(t);
      });
    });

    /* ---------- Topic pre-selection ---------- */
    var topicSelect = $('#cfTopic');
    function preselectTopic(topic) {
      if (!topicSelect || !topic) return;
      var has = $$('option', topicSelect).some(function (o) { return o.value === topic; });
      if (has) {
        topicSelect.value = topic;
        topicSelect.style.transition = 'box-shadow .3s';
        topicSelect.style.boxShadow = '0 0 0 4px rgba(59,176,170,.18)';
        setTimeout(function () { topicSelect.style.boxShadow = ''; }, 900);
      }
    }

    /* ---------- Track / exchange routing (popup vs separate page) ---------- */
    function goTrack() {
      if (cfg.trackMode === 'page' && cfg.trackPage) { window.location.href = cfg.trackPage; return; }
      openModal('trackModal');
    }
    function goExchange() {
      if (cfg.exMode === 'page' && cfg.returnsPage) { window.location.href = cfg.returnsPage; return; }
      openModal('exchangeModal');
    }
    function goSizeGuide() {
      if (cfg.sizeGuide) { window.location.href = cfg.sizeGuide; }
    }

    /* help cards */
    $$('.help-card').forEach(function (card) {
      card.addEventListener('click', function () {
        var action = card.getAttribute('data-action');
        var topic = card.getAttribute('data-topic');
        if (action === 'size_guide') { goSizeGuide(); return; }
        if (action === 'exchange')   { goExchange(); return; }
        if (action === 'track')      { goTrack(); return; }
        if (action === 'email')      { var m = card.getAttribute('data-email'); if (m) window.location.href = 'mailto:' + m; return; }
        // default: scroll to form, preselect topic
        preselectTopic(topic);
        scrollToEl($('#contact-form'));
        setTimeout(function () { var n = $('#cfName'); if (n) n.focus({ preventScroll: true }); }, reduce ? 0 : 650);
      });
    });

    /* quick tiles + buttons with explicit actions */
    $$('[data-act]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var act = el.getAttribute('data-act');
        if (act === 'track')      { e.preventDefault(); goTrack(); }
        else if (act === 'exchange') { e.preventDefault(); goExchange(); }
        else if (act === 'size_guide') { e.preventDefault(); goSizeGuide(); }
      });
    });

    /* ---------- Contact form ---------- */
    var form = $('#contactForm');
    if (form) {
      function setInvalid(field, bad) {
        var f = field.closest('.cf-field');
        if (f) f.classList.toggle('invalid', bad);
        return !bad;
      }
      $$('.cf-input, .cf-textarea, .cf-select', form).forEach(function (el) {
        el.addEventListener('input', function () { var f = el.closest('.cf-field'); if (f) f.classList.remove('invalid'); });
      });
      form.addEventListener('submit', function (e) {
        var name = $('#cfName'), email = $('#cfEmail'), msg = $('#cfMsg'), agree = $('#cfAgree');
        var ok = true;
        ok = setInvalid(name, !name.value.trim()) && ok;
        ok = setInvalid(email, !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value.trim())) && ok;
        ok = setInvalid(msg, !msg.value.trim()) && ok;
        if (!agree.checked) { ok = false; toast('Please agree to the terms to continue'); }
        if (!ok) {
          e.preventDefault();
          var firstBad = $('.cf-field.invalid');
          if (firstBad) scrollToEl(firstBad, 140);
          return;
        }
        var btn = $('.cf-submit', form);
        btn.classList.add('loading');
      });
    }

    /* ---------- FAQ accordion ---------- */
    $$('.faq-item').forEach(function (item) {
      var q = $('.faq-q', item), a = $('.faq-a', item);
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        $$('.faq-item.open').forEach(function (other) {
          if (other !== item) { other.classList.remove('open'); var oa = $('.faq-a', other); if (oa) oa.style.maxHeight = '0px'; }
        });
        if (isOpen) { item.classList.remove('open'); a.style.maxHeight = '0px'; }
        else { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
    window.addEventListener('resize', function () {
      var open = $('.faq-item.open'); if (open) { var a = $('.faq-a', open); if (a) a.style.maxHeight = a.scrollHeight + 'px'; }
    }, { passive: true });

    /* ---------- Order / Exchange modals ---------- */
    var lastFocus = null;
    function openModal(id) {
      var m = $('#' + id); if (!m) return;
      lastFocus = document.activeElement;
      var fv = $('.ohub-form-view', m), sv = $('.ohub-success', m);
      if (fv) fv.style.display = '';
      if (sv) sv.classList.remove('show');
      m.classList.add('open'); m.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var first = $('input, select', m);
      setTimeout(function () { if (first) first.focus(); }, 130);
    }
    function closeModal(m) {
      m.classList.remove('open'); m.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
    }
    $$('[data-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); openModal(el.getAttribute('data-open')); });
    });
    $$('.ohub-modal').forEach(function (m) {
      m.addEventListener('click', function (e) {
        if (e.target.closest('[data-mclose]') || e.target.classList.contains('ohub-scrim')) closeModal(m);
      });
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { var op = $('.ohub-modal.open'); if (op) closeModal(op); }
    });

    function validField(el, ok) { var f = el.closest('.cf-field'); if (f) f.classList.toggle('invalid', !ok); return ok; }
    function emailOk(v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((v || '').trim()); }
    $$('.ohub-modal .cf-input, .ohub-modal .cf-select, .ohub-modal .cf-textarea').forEach(function (el) {
      var clear = function () { var f = el.closest('.cf-field'); if (f) f.classList.remove('invalid'); };
      el.addEventListener('input', clear); el.addEventListener('change', clear);
    });

    var trackForm = $('#trackForm');
    if (trackForm) {
      trackForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var order = $('#tkOrder'), email = $('#tkEmail'), ok = true;
        ok = validField(order, !!order.value.trim()) && ok;
        ok = validField(email, emailOk(email.value)) && ok;
        if (!ok) return;
        var btn = $('.ohub-submit', trackForm); btn.classList.add('loading');
        setTimeout(function () {
          var data = { order: order.value.trim(), email: email.value.trim() };
          $('#trackChip').textContent = data.order;
          $('#trackGo').setAttribute('href', buildUrl(cfg.trackUrl, data));
          $('#trackFormView').style.display = 'none';
          $('#trackSuccess').classList.add('show');
          btn.classList.remove('loading');
        }, 900);
      });
    }

    var exForm = $('#exForm');
    if (exForm) {
      exForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var order = $('#exOrder'), email = $('#exEmail'), item = $('#exItem'), cur = $('#exCurSize'), nw = $('#exNewSize'), ok = true;
        ok = validField(order, !!order.value.trim()) && ok;
        ok = validField(email, emailOk(email.value)) && ok;
        ok = validField(item, !!item.value.trim()) && ok;
        ok = validField(cur, !!cur.value) && ok;
        ok = validField(nw, !!nw.value) && ok;
        if (!ok) return;
        var btn = $('.ohub-submit', exForm); btn.classList.add('loading');
        setTimeout(function () {
          var data = { order: order.value.trim(), email: email.value.trim() };
          $('#exChip').textContent = data.order;
          $('#exGo').setAttribute('href', buildUrl(cfg.returnsUrl, data));
          $('#exFormView').style.display = 'none';
          $('#exSuccess').classList.add('show');
          btn.classList.remove('loading');
          /* DEVELOPER: also POST these details to your returns app / endpoint. */
        }, 950);
      });
    }

    /* ---------- Sticky mobile help button ---------- */
    var sticky = $('#stickyHelp');
    if (sticky) {
      var formSec = $('#contact-form');
      var onScrollSticky = function () {
        var past = window.scrollY > window.innerHeight * 0.7;
        var nearForm = false;
        if (formSec) { var r = formSec.getBoundingClientRect(); nearForm = r.top < window.innerHeight && r.bottom > 0; }
        sticky.classList.toggle('show', past && !nearForm);
      };
      window.addEventListener('scroll', onScrollSticky, { passive: true });
      onScrollSticky();
    }

    /* ---------- Toast ---------- */
    var toastZone = $('#toastZone');
    function toast(msg) {
      if (!toastZone) return;
      var t = document.createElement('div');
      t.className = 'toast';
      t.innerHTML = '<span class="tk"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5L20 6"/></svg></span><span></span>';
      t.lastChild.textContent = msg;
      toastZone.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('show'); });
      setTimeout(function () { t.classList.remove('show'); setTimeout(function () { t.remove(); }, 400); }, 3200);
    }

    /* ---------- Rain canvas (hero) ---------- */
    (function initRain() {
      var canvas = $('#heroRain');
      if (!canvas || reduce) return;
      var ctx = canvas.getContext('2d');
      var host = canvas.parentElement;
      var W = 0, H = 0, dpr = 1, drops = [], running = false, inView = false;
      var COUNT = 70, COLOR = '150,200,212';
      function resize() {
        dpr = Math.min(2, window.devicePixelRatio || 1);
        var r = host.getBoundingClientRect(); W = r.width; H = r.height;
        canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      function seed() {
        drops = [];
        for (var i = 0; i < COUNT; i++) {
          drops.push({ x: Math.random() * W, y: Math.random() * H, len: 9 + Math.random() * 16, v: 6 + Math.random() * 8, a: 0.05 + Math.random() * 0.14 });
        }
      }
      function loop() {
        ctx.clearRect(0, 0, W, H); ctx.lineWidth = 1.1;
        for (var i = 0; i < drops.length; i++) {
          var d = drops[i];
          ctx.strokeStyle = 'rgba(' + COLOR + ',' + d.a + ')';
          ctx.beginPath(); ctx.moveTo(d.x, d.y); ctx.lineTo(d.x - 1.5, d.y + d.len); ctx.stroke();
          d.y += d.v; d.x -= 0.4;
          if (d.y > H) { d.y = -d.len; d.x = Math.random() * W; }
        }
        if (inView) requestAnimationFrame(loop); else running = false;
      }
      function start() { if (!running) { running = true; requestAnimationFrame(loop); } }
      resize(); seed(); inView = true; start();
      window.addEventListener('resize', function () { resize(); seed(); }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { inView = e.isIntersecting; if (inView) start(); });
        }, { threshold: 0.02 }).observe(host);
      }
    })();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('.oszea-ct')).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme Editor: a section can be re-rendered at any time. */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('.oszea-ct') : null;
    if (el) { el.__oszeaCtBound = false; init(el); }
  });
})();
